import {
  Button,
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import React from "react";
import {
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
  percentFormatter,
  dateFormatterMomentV4,
  percentFormatterWithDecimal,
} from "../../util/customFunctions";
import { getMixKey } from "../../util/generateHeadings";

import StyledTableRow from "../../components/StyledTableRow";
import * as d3 from "d3";
import { deSnake } from "../../util/dataFormatter";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
import { replaceAll } from "../../components/xlsx-export/LabelCange";
// import RepBenchMarkExcelExportButton from "../../components/xlsx-export/RepBenchMark";
const useStyle = makeStyles((theme) => ({
  root: {},
  content: { width: "100%" },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "100%",
  },
  colHeader: {
    fontSize: "0.85rem",
    border: "0.5px solid lightgrey",
    padding: "7px 7px",
    color: "inherit",
    fontWeight: "inherit",
  },
  segmentHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repHeader: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repHeader1: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    fontWeight: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
  },
  fontBold: {
    fontWeight: 600,
  },
  tableColWidth: {
    minWidth: 90,
  },
  drilldownCell: {
    cursor: "pointer",
  },
}));
export default function AdditionalPipelineTable(props) {
  const classes = useStyle();
  const tableRef = React.createRef();

  const uniqueQuarters = props.data.map((item) => item.quarter)
      .filter(getUniqueValues).filter(f => f !== 'Total').length
  const createdrow1 = (uniqueQuarters > 0 && props.data.filter(f => f.quarter === 'Total').reduce((a,b) => a+b.createdACV, 0) > 0) ? props.data.filter(f => f.quarter === 'Total').reduce((a,b) => a+b.createdACV, 0) / uniqueQuarters : 0
  const conversionRaterow1 = props.data.filter(f => f.quarter === 'Total').reduce((a,b) => a+b.convPerc, 0)
  const gapToFill = Math.max(props.gap, 0);
  const required = (gapToFill > 0 && conversionRaterow1 > 0) ? Math.round((gapToFill / conversionRaterow1) / 1000) * 1000 : 0
  const cr = props.cr1


  return (
    <div
      className={classes.root}
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <CardContent className={classes.content} style={{ padding: 10 }}>
        <Grid container justify="center">
          <TableContainer style={{ width: "auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "10px",
                // marginRight: "10px",
              }}
            >
              <CopyTablesObject tableRef={tableRef} />
            </div>
            <Table
              ref={tableRef}
              data-test={"pipeline"}
              size="small"
              aria-label="html table"
              style={{ tableLayout: "auto", width: "initial" }}
            >
              <TableHead>
                <TableRow style={{ fontWeight: 600 }}>
                  <TableCell
                    align="center"
                    className={`${classes.repHeader1} ${classes.fontBold}`}
                    colSpan={1}
                  >
                   
                  </TableCell>
                  <React.Fragment>
                    <TableCell
                      align="center"
                      className={classes.repHeader1}
                      colSpan={1}
                      style={{ width: '100px', background: "#4471c4", color: "white" }}
                    >
                      Created
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.repHeader1}
                      colSpan={1}
                      style={{ width: '100px', background: "#5b9bd5", color: "white" }}
                    >
                      Conversion Rate
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.repHeader1}
                      colSpan={1}
                      style={{ width: '100px', background: "#4471c4", color: "white" }}
                    >
                      Converted
                    </TableCell>
                  </React.Fragment>
                </TableRow>
              </TableHead>
              <TableBody>
               
                    <StyledTableRow key={1}>
                 
                          <TableCell
                            align="left"
                            className={`${classes.repText} ${classes.fontBold}`}
                            colSpan={1}
                            style={{width: '250px'}}
                          >
                            Qualified Pipeline projected to be created and converted based on historical trends
                          </TableCell>

                          <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                            
                          >
                           {countOrACVFormatter(createdrow1, true)}
                          </TableCell>

                          <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                          >
                            {percentFormatterWithDecimal(conversionRaterow1)}
                          </TableCell>

                          <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                          >
                            {countOrACVFormatter(cr, true)}
                          </TableCell>
                                 
                    </StyledTableRow>

                    <StyledTableRow key={2}>
                 
                 <TableCell
                   align="left"
                   className={`${classes.repText} ${classes.fontBold}`}
                   colSpan={1}
                   style={{width: '250px'}}
                 >
                   Additional Qualified Pipeline needed to meet the goal above
                 </TableCell>

                 <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                            style={{background: '#e2efda'}}
                          >
                           {countOrACVFormatter(required, true)}
                          </TableCell>

                          <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                          >
                            {percentFormatterWithDecimal(conversionRaterow1)}
                          </TableCell>

                          <TableCell
                            align="right"
                            className={`${classes.repNumber} ${classes.fontBold}`}
                            colSpan={1}
                          >
                            {countOrACVFormatter(gapToFill, true)}
                          </TableCell>
                        
           </StyledTableRow>

          

   
                

        

              </TableBody>
            </Table>


          </TableContainer>
        </Grid>
      </CardContent>
    </div>
  );
}
